import React from "react";
import { makeStyles } from "@material-ui/core/styles";
import MapApp from "../components/MapApp";
import Typography from "@material-ui/core/Typography";
import List from "@material-ui/core/List";
import ListItem from "@material-ui/core/ListItem";
import ListItemText from "@material-ui/core/ListItemText";
import Card from "@material-ui/core/Card";
import CardContent from "@material-ui/core/CardContent";
import {anmodning_id, anmodning_fill} from "../libs/mapStyles"
import { format } from "ol/coordinate";


const useStyles = makeStyles((theme) => ({
  root: {
    backgroundColor: theme.palette.background.paper,
    flexGrow: 1,
  },
   
  statusDone: {
    height: "14px" ,
    width: "50px" ,
    display:'inline-block',
    opacity : 0.5,
    padding: '5px',
    color:'#ffffff',
    marginLeft: 0,
    marginRight: '20px',
    border:'1px solid black',
    backgroundColor:'#0080ff',
  },

  statusFetched :{
    height: "14px" ,
    width: "50px" ,
    display:'inline-block',
    opacity : 0.5,
    padding: '5px',
    color:'#ffffff',
    marginLeft: 0,
    marginRight: '20px',
    border:'1px solid black',
    backgroundColor:'#EAEB06',
  },
  statusOther :{
    height: "14px" ,
    width: "50px" ,
    display:'inline-block',
    opacity : 0.5,
    padding: '5px',
    color:'#ffffff',
    marginLeft: 0,
    marginRight: '4px',
    border:'1px solid black',
    backgroundColor:'#ff80ff',
  },
  anmodningSignature: {
    position: 'absolute',
    zIndex: 1,
    left: '10px',
  },

  containerAnmodning: {
    display: 'flex',
    flexDirection: 'column',
    width: '100%',
    maxWidth: '100%',
    overflowY: 'hidden'
  },
  
  mapItem: {
    display: 'flex',
    flexDirection: 'column',
    minHeight: 0,
  },

  listitem: {},
}));

export default function Anmodninger({ ...props }) {
  const classes = useStyles();

  const anmodn = props.anmodninger.anmodninger;
  const hasAnmodninger = anmodn?.features && anmodn.features.length > 0;
 
  const layers = [{
    geojson: props.anmodninger.anmodninger,
    id: anmodning_id,
    style: [anmodning_fill],
    searchable: true,
    searchableProperty: 'graveforespoergselsnr',
    searchLabel: 'graveforespørgsel',
    popupTemplate: (properties, feature) => {
        return (
            <div>
                <h6>Anmodning</h6>
                <p>Forespørgsel: {properties.graveforespoergselsnr}/{properties.interesseomraade}</p>
                <a href={`/anmodning/${properties.anmod_id}`}>Gå til anmodning</a>
            </div>
        );
    },
  }];

  return (
    <div className={classes.containerAnmodning}>
      <Card raised className={classes.mapItem}>
        {!hasAnmodninger ? (
          <CardContent>
            <List>
              <ListItem className={classes.listitem}>
                <ListItemText>Forsøger at hente anmodninger. / Der er ikke valgt en profil.</ListItemText>
              </ListItem>
            </List>
          </CardContent>
        ) : (
          <CardContent style={{ display: 'flex', flexDirection: 'column', flex: 1, minHeight: 0, padding: 0 }}>
            <div style={{ flex: 1, minHeight: 0, display: 'flex', flexDirection: 'column' }}>
              <MapApp
                clickable={true}
                layer={layers}
                search={false}
                height="500px"
              />
            </div>
          </CardContent>
        )}
      </Card>
    </div>
  );
}
